import React from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import Text from 'design-system/Text';
const Disclaimer = () => (<Text TextThin-14 Secondary flex centered style={styles.text}>
    We have some of the best cashback deals since we don’t take any cut.
  </Text>);
const styles = StyleSheet.create({
    text: {
        marginHorizontal: rem(16),
    },
});
export default Disclaimer;
